<template>
  <div class="toggle xsmall">
    <div class="label ">{{ label }}</div>
    <div class="indicator" :class="{active: state}" @click="update">{{ state_txt }}</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      set: undefined
    };
  },
  methods: {
    update () {
      if (typeof this.set === 'undefined') {
        this.set = !this.default;
      }
      else {
        this.set = !this.set;
      }

      this.$emit('update', this.set);
    }
  },
  computed: {
    state () {
      return typeof this.set === 'undefined' ? this.default : this.set;
    },
    state_txt () {
      return this.state === true ? this.onTxt : this.offTxt;
    }
  },
  props: {
    label: String,
    default: Boolean,
    onTxt: {
      type: String,
      default: 'YES'
    },
    offTxt: {
      type: String,
      default: 'NO'
    }
  }
};
</script>

<style scoped lang="scss">
  .toggle {
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    user-select: none;
    width: 25%;
  }
  .indicator {
    cursor: pointer;
    color: #878787;
    font-weight: 600;
    padding: 10px;
  }
    .indicator.active {
      color: #000;
    }

  .label {
    text-align: left;
  }
</style>
